/**
 * Panel de reglas en lenguaje llano (MVP §3 y §6).
 *
 * La nota sobre las salas nunca vacías no es decorativa: sin ella el jugador lee
 * «fue la primera en entrar en el sótano» como una pista más débil de lo que es.
 *
 * El texto describe la rejilla tal y como se pinta: **salas en columnas, horas en
 * filas, y en la casilla la persona**. Si la UI cambiara de ejes, este texto miente y
 * hay que cambiarlo con ella.
 */

import { periodPhrase } from './render';
import type { ThemePack } from './schema';

export interface RulesText {
  title: string;
  intro: string;
  rules: readonly [string, string];
  note: string;
}

export function rulesFor(pack: ThemePack): RulesText {
  const period = periodPhrase(pack);
  const de = period.startsWith('el ') ? `del ${period.slice(3)}` : `de ${period}`;
  return {
    title: 'Cómo se lee el caso',
    intro:
      'Cada columna es una sala y cada fila, una hora. En cada casilla va la persona que estuvo en esa sala a esa hora. Dos reglas lo gobiernan todo:',
    rules: [
      'En cada fila, cada persona aparece una sola vez: nadie está en dos salas a la vez, y ninguna sala se queda vacía.',
      `En cada columna, cada persona aparece una sola vez: a lo largo ${de} todos pasan por todas las salas, y por cada una solo una vez.`,
    ],
    note: 'Ojo: como ninguna sala queda vacía nunca, quien «fue la primera en entrar» en una sala estaba allí a primera hora, y quien «fue el último en pisarla», a última. Esas pistas dicen más de lo que parece.',
  };
}
